import { render, staticRenderFns } from "./FormatText.vue?vue&type=template&id=09ab38c8&"
import script from "./FormatText.vue?vue&type=script&lang=js&"
export * from "./FormatText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports